const getLocationByCustomerIdQuery = (paymentProvider, customerId) => {
  return {
    query: `
      select
        l.fsid,
        pc.location_id,
        ql."company_code",
        ql.quickbooks_customer_id as customer_id
      from avocado.payment_customers pc
      left join avocado.data_location l on pc.location_id = l."uuid" 
      left join avocado.data_quickbookslocation ql on ql.location_id = l.uuid
      where pc.payment_provider = $1 and pc.external_id = $2 and lower(ql.company_code) != 'legacy'`,
    values: [paymentProvider, customerId],
    queryName: 'getLocationByCustomerIdQuery'
  }
}

const getLocationByUuidQuery = (locationUuid) => {
  return {
    query: `
      select
        l.fsid,
        l.uuid as location_id,
        ql."company_code",
        ql.quickbooks_customer_id as customer_id
      from avocado.data_location l 
      left join avocado.data_quickbookslocation ql on ql.location_id = l.uuid
      where l.uuid = $1 and lower(ql.company_code) != 'legacy'
    `,
    values: [locationUuid],
    queryName: 'getLocationByUuidQuery'
  }
}

module.exports = {
  getLocationByCustomerIdQuery,
  getLocationByUuidQuery
}
